<template>
  <b-container fluid>
    <h1 class="display-title">Detalle dias licencia</h1>
    <b-row class="my-4">
      <b-col md="4">
        <b-btn size="sm" variant="success" v-b-modal.modalNuevo>
          <b-icon icon="plus"></b-icon>Agregar
        </b-btn>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-input-group size="sm">
            <b-form-input v-model="filter" placeholder="Buscar" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''" variant="primary"
                >Limpiar</b-btn
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group size="sm" horizontal label="Por página: " class="mb-0">
          <b-form-select
            size="sm"
            :options="pageOptions"
            v-model="perPage"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="segunda-fila">
      <b-col lg="12">
        <b-table
          ref="tablaTipoLicencia"
          stacked="md"
          responsive
          striped
          hover
          :items="myProvider"
          :fields="fields"
          :filter="filter"
          @filtered="onFiltered"
          :per-page="perPage"
          :current-page="currentPage"
          empty-filtered-text="No se encontraron registros"
        >
          <!-- Template para detalles-->
          <template slot="show_details" slot-scope="row">
            <!--Boton remover-->
            <b-button
              @click.stop="getFormData(row.item)"
              variant="primary"
              size="sm"
              title="Editar"
            >
              <b-icon icon="edit"></b-icon>
            </b-button>
            <!--Boton remover-->
            <b-button
              @click.stop="modalEliminar(row.item, row.index, $event.target)"
              variant="primary"
              size="sm"
              title="Remover"
            >
              <b-icon icon="trash-alt"></b-icon>
            </b-button>
          </template>
          <!-- Template para dar formato a columna DiasContinuos -->
          <template slot="DiasContinuos" slot-scope="row">{{
            row.value ? "Si" : "No"
          }}</template>
          <template slot="DiasHabiles" slot-scope="row">{{
            row.value ? "Si" : "No"
          }}</template>
        </b-table>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col md="4">
        <p>
          Mostrando {{ currentPage }} a {{ perPage }} de {{ totalRows }} items
        </p>
      </b-col>
      <b-col md="8">
        <b-pagination
          size="sm"
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
        ></b-pagination>
      </b-col>
      <b-col md="6"></b-col>
    </b-row>
    <!-- Modal nuevo detalle-->
    <b-modal
      id="modalNuevo"
      ref="modal"
      title="Nuevo Detalle "
      ok-title="Guardar"
      ok-variant="primary"
      cancel-title="Cancelar"
      @shown="limpiarFormulario"
      @ok="crearDetalle"
      header-bg-variant="dark"
      header-text-variant="light"
      size="lg"
    >
      <b-container fluid>
        <!-- Formulario nuevo tipo de licencia-->
        <b-form id="frmNuevaLicencia" @submit.stop.prevent="handleSubmit">
          <b-form-row>
            <b-col cols="12">
              <!--Select tipo de licencia-->
              <b-form-group>
                <div>
                  <label class="typo__label" for="msArticulo"
                    >Artículo N°</label
                  >
                  <multiselect
                    v-model="articuloSelected"
                    id="msArticulo"
                    label="Articulo"
                    track-by="Id"
                    placeholder="Haga click para buscar"
                    open-direction="bottom"
                    :max-height="900"
                    :custom-label="customLabel"
                    :options="arregloArticulos"
                    :searchable="true"
                    :internal-search="false"
                    :clear-on-select="false"
                    @search-change="findByNameArticle"
                    :close-on-select="true"
                    :show-no-results="false"
                    :disabled="disabled"
                  >
                    <span slot="noResult"
                      >Oops! No se encontraron resultados.</span
                    >
                  </multiselect>
                </div>
              </b-form-group>
              <!--Descripcion-->
              <b-form-group
                id="exampleInputGroup2"
                label="Descripcion:"
                label-for="exampleInput2"
              >
                <b-form-input
                  id="exampleInput2"
                  ref="focusThis"
                  v-model="txtDescripcion"
                  type="text"
                  :disabled="disabled"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="grupoFrecuencia"
                label="Frecuencia:"
                label-for="grupoFrecuencia"
              >
                <multiselect
                  v-model="frecuenciaSelected"
                  track-by="Id"
                  label="Text"
                  placeholder="--Seleccionar--"
                  :options="frecuencia"
                  :searchable="true"
                  :allow-empty="false"
                  :max-height="600"
                  :disabled="disabled"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <strong>{{ option.Text }}</strong>
                  </template>
                  <span slot="noResult"
                    >Oops! No se encontraron resultados.</span
                  >
                </multiselect>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <!--Antiguedad dias-->
            <b-col cols="4">
              <b-form-group
                id="exampleInputGroup3"
                label="Antigüedad Dias:"
                label-for="exampleInput3"
              >
                <b-form-input
                  id="exampleInput3"
                  v-model="txtAntiguedad"
                  type="number"
                  :disabled="disabled"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <!--Minimo de dias-->
            <b-col cols="4">
              <b-form-group
                id="exampleInputGroup4"
                label="Mínimo Dias:"
                label-for="exampleInput4"
              >
                <b-form-input
                  id="exampleInput4"
                  v-model="txtMinimoDias"
                  type="number"
                  :disabled="disabled"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <!--Maximo de dias-->
            <b-col cols="4">
              <b-form-group
                id="exampleInputGroup5"
                label="Máximo Dias:"
                label-for="exampleInput5"
              >
                <b-form-input
                  id="exampleInput5"
                  v-model="txtMaximoDias"
                  type="number"
                  :disabled="disabled"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <!--Dias continuos-->
            <b-col cols="4">
              <b-form-group
                id="exampleInputGroup6"
                label="Dias Corridos: "
                label-for="exampleInput6"
              >
                <b-form-select
                  v-model="continuosSelected"
                  :options="continuos"
                  class="mb-3"
                  id="selectContinuos"
                  :disabled="disabled"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <!--Dias habiles-->
            <b-col cols="4">
              <b-form-group
                id="grupoDiasHabiles"
                label="Dias Hábiles: "
                label-for="somHabiles"
              >
                <b-form-select
                  v-model="habilSelected"
                  :options="diasHabiles"
                  class="mb-3"
                  id="somHabiles"
                  :disabled="disabled"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <!--Porcentaje de sueldo-->
            <b-col cols="4">
              <b-form-group
                id="exampleInputGroup7"
                label="Sueldo % :"
                label-for="exampleInput7"
              >
                <b-form-select
                  v-model="porcentajeSelected"
                  :options="porcentaje"
                  class="mb-3"
                  id="selectPorcentaje"
                  :disabled="disabled"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-form>
      </b-container>
    </b-modal>
    <!--Modal Edicion-->
    <b-modal
      id="modalEdicion"
      title="Editar Detalle "
      ok-title="Actualizar"
      ok-variant="success"
      cancel-title="Cancelar"
      @ok="cambiarLicencia"
      header-bg-variant="dark"
      header-text-variant="light"
      size="lg"
    >
      <b-container fluid>
        <!-- Formulario nuevo tipo de licencia-->
        <b-form id="frmEditarLicencia" @submit.stop.prevent="handleSubmit">
          <!-- Primera Fila-->
          <b-form-row>
            <b-col cols="12">
              <!--Select tipo de licencia-->
              <b-form-group>
                <div>
                  <label class="typo__label" for="msArticulo"
                    >Artículo N°</label
                  >
                  <multiselect
                    v-model="articuloSelected"
                    id="msArticulo"
                    label="Text"
                    track-by="Id"
                    placeholder="Haga click para buscar"
                    open-direction="bottom"
                    :max-height="900"

                    :options="arregloArticulos"
                    :searchable="true"
                    :internal-search="false"
                    :clear-on-select="false"
                    @search-change="findByNameArticle"
                    :close-on-select="true"
                    :show-no-results="false"
                    :disabled="disabled"
                  >
                    <span slot="noResult"
                      >Oops! No se encontraron resultados.</span
                    >
                  </multiselect>
                </div>
              </b-form-group>
              <!--Descripcion-->
              <b-form-group
                id="grupoEditar2"
                label="Descripcion:"
                label-for="txtDescripcionE"
              >
                <b-form-input
                  id="txtDescripcionE"
                  ref="focusThis"
                  v-model="txtDescripcion"
                  type="text"
                  required
                  :disabled="disabled"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="grupoFrecuencia"
                label="Frecuencia:"
                label-for="grupoFrecuencia"
              >
                <multiselect
                  v-model="frecuenciaSelected"
                  track-by="Id"
                  label="Text"
                  placeholder="--Seleccionar--"
                  :options="frecuencia"
                  :searchable="true"
                  :allow-empty="false"
                  :max-height="600"
                  :disabled="disabled"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <strong>{{ option.Text }}</strong>
                  </template>
                  <span slot="noResult"
                    >Oops! No se encontraron resultados.</span
                  >
                </multiselect>
              </b-form-group>
            </b-col>
          </b-form-row>
          <!--Segunda Fila-->
          <b-form-row>
            <!--Antiguedad dias-->
            <b-col cols="4">
              <b-form-group
                id="grupoEditar3"
                label="Antigüedad Dias:"
                label-for="txtAntiguedadE"
              >
                <b-form-input
                  id="txtAntiguedadE"
                  v-model="txtAntiguedad"
                  type="number"
                  required
                  :disabled="disabled"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <!--Minimo de dias-->
            <b-col cols="4">
              <b-form-group
                id="grupoEditar4"
                label="Mínimo Dias:"
                label-for="txtMaximoDiasE"
              >
                <b-form-input
                  id="txtMinimoDiasE"
                  v-model="txtMinimoDias"
                  type="number"
                  required
                  :disabled="disabled"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <!--Maximo de dias-->
            <b-col cols="4">
              <b-form-group
                id="grupoEditar5"
                label="Máximo Dias:"
                label-for="txtMaximoDiasE"
              >
                <b-form-input
                  id="txtMaximoDiasE"
                  v-model="txtMaximoDias"
                  type="number"
                  required
                  :disabled="disabled"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <!--Tercera Fila-->
          <b-form-row>
            <!--Dias continuos-->
            <b-col cols="4">
              <b-form-group
                id="grupoEditar6"
                label="Dias Continuos: "
                label-for="selectContinuosE"
              >
                <b-form-select
                  v-model="continuosSelected"
                  :options="continuos"
                  class="mb-3"
                  id="selectContinuosE"
                  :disabled="disabled"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <!--Dias habiles-->
            <b-col cols="4">
              <b-form-group
                id="grupoDiasHabiles"
                label="Dias Hábiles: "
                label-for="somHabiles"
              >
                <b-form-select
                  v-model="habilSelected"
                  :options="diasHabiles"
                  class="mb-3"
                  id="somHabiles"
                  :disabled="disabled"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <!--Porcentaje de sueldo-->
            <b-col cols="4">
              <b-form-group
                id="grupoEditar7"
                label="Sueldo % :"
                label-for="selectPorcentajeE"
              >
                <b-form-select
                  v-model="porcentajeSelected"
                  :options="porcentaje"
                  class="mb-3"
                  id="selectPorcentajeE"
                  :disabled="disabled"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-form>
      </b-container>
    </b-modal>
    <!-- Modal Component -->
    <b-modal
      id="modalEliminar"
      title="Remover Detalle"
      @ok="eliminarLicencia"
      ok-variant="success"
      ok-title="Si"
      cancel-title="No"
      header-bg-variant="dark"
      header-text-variant="light"
    >
      <p class="my-4">¿Esta seguro que desea eliminar este registro ?</p>
    </b-modal>
  </b-container>
</template>
<!-- Scripts-->
<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import axios from "axios";
import DetalleDiasLicenciaSvc from "@/services/detallediaslicencia";
import TipoLicenciaSvc from "@/services/tipolicencia";
import Multiselect from "vue-multiselect";

export default {
  name: 'RegimenLicencia',
  mixins: [errorhandler, swalerts],
  // OR register locally
  components: { Multiselect },
  data() {
    return {
      disabled: null,
      color: "#0069d9",
      w: 1000,
      h: "20px",
      value: {},
      filter: "",
      totalRows: null,
      perPage: 10,
      currentPage: 1,
      pageOptions: [5, 10, 15],
      fields: [
        {
          key: 'TipoLicencia.Articulo',
          label: 'Articulo',
          sortable: true
        },
        {
          key: 'Descripcion',
          label: 'Descripción',
        },
        {
          key: 'AntiguedadDias',
          label: 'Ant.',
          class: "text-center"
        },
        {
          key: 'MaximoDias',
          label: 'Max.',
          class: "text-center"
        },
        {
          key: 'MinimoDias',
          label: 'Min.',
          class: "text-center"
        },
        {
          key: 'PorcentajeSueldo',
          label: '% Sueldo',
          class: "text-center"
        },
        {
          key: 'DiasContinuos',
          label: 'Corridos',
          class: "text-center"
        },
        {
          key: 'DiasHabiles',
          label: 'Hábiles',
          class: "text-center"
        },
        {
          key: 'show_details',
          label: 'Acciones',
          class: "text-center"
        },
      ],
      posts: [],
      options: [],
      frecuencia: [],
      articuloSelected: [],
      arregloArticulos: [],
      selected: null,
      txtDescripcion: "",
      status: "",
      text: "",
      continuosSelected: null,
      porcentajeSelected: null,
      frecuenciaSelected: null,
      habilSelected: null,
      txtMaximoDias: "",
      txtMinimoDias: "",
      txtAntiguedad: "",
      idSeleccionado: "",
      tipolicencia: null,
      diasHabiles: [
        { value: null, text: "--Seleccionar--" },
        { value: true, text: "Si" },
        { value: false, text: "No" }
      ],
      continuos: [
        { value: null, text: "--Seleccionar--" },
        { value: true, text: "Si" },
        { value: false, text: "No" }
      ],
      porcentaje: [
        { value: null, text: "--Seleccionar--" },
        { value: 100, text: "100 %" },
        { value: 75, text: "75 %" },
        { value: 50, text: "50 %" },
        { value: 0, text: "0 %" }
      ]
    };
  },
  watch: {
    continuosSelected: function(val, oldVal) {
      console.log("new: %s, old: %s", val, oldVal);
    },
    porcentajeSelected: function(val, oldVal) {
      console.log("new: %s, old: %s", val, oldVal);
    }
  },
  methods: {
    customLabel({ Regimen, Articulo, Descripcion }) {
      return `${Regimen} – ${Articulo} - ${Descripcion}`;
    },

    findByNameArticle(query) {
      this.arregloArticulos = [];
      this.findArticle(query)
        .then(response => {
          this.arregloArticulos = response.data.rows;
        })
        .catch(error => {
          console.log("Error al obtener artículos");
        });
    },

    findArticle(query) {
      return TipoLicenciaSvc.getLista({ search: query });
    },

    crearDetalle(evt) {
      evt.preventDefault();
      if (!this.articuloSelected) {
        alert("Por favor seleccione un artículo");
      } else if (!this.txtDescripcion) {
        alert("Por favor complete el campo descripción");
      } else if (!this.txtAntiguedad) {
        alert("Por favor indique la antigüedad de dias necesarios");
      } else if (this.continuosSelected == null) {
        alert("Por favor indique si los dias son corridos o no");
      } else if (this.porcentajeSelected == null) {
        alert("Por favor indique un porcentaje de sueldo");
      } else {
        this.desactivarBoton();
        this.crearDetalleDiasLicencia()
          .then(r => {
            this.activarBoton();
            this.showSuccess("Licencia agregada exitosamente");
            this.$refs.tablaTipoLicencia.refresh();
            this.handleSubmit();
          })
          .catch(e => {
            this.errorHandler(e);
          });
      }
    },
    crearDetalleDiasLicencia() {
      return DetalleDiasLicenciaSvc.crear({
        TipoLicencia_Id: this.articuloSelected.Id,
        Descripcion: this.txtDescripcion,
        AntiguedadDias: this.txtAntiguedad,
        MinimoDias: this.txtMinimoDias,
        MaximoDias: this.txtMaximoDias,
        DiasContinuos: this.continuosSelected,
        PorcentajeSueldo: this.porcentajeSelected,
        Frecuencia: this.frecuenciaSelected
      });
    },
    desactivarBoton() {
      this.disabled = true;
    },

    activarBoton() {
      this.disabled = false;
    },

    getFormData(item) {
      DetalleDiasLicenciaSvc.getFormData(item.Id)
        .then(response => {
          var selectedValue =
            response.data.objeto.ListaTipoLicencia.SelectedValue;
          response.data.objeto.ListaTipoLicencia.Lista.forEach(a => {
            console.log("objeto: ", a);
            if (a.Id === selectedValue) {
              this.articuloSelected = a;
            }
          });
          this.idSeleccionado = response.data.objeto.Id;
          this.tipolicencia = response.data.objeto.TipoLicencia_Id;
          this.txtDescripcion = response.data.objeto.Descripcion;
          this.txtAntiguedad = response.data.objeto.AntiguedadDias;
          this.txtMinimoDias = response.data.objeto.MinimoDias;
          this.txtMaximoDias = response.data.objeto.MaximoDias;
          this.continuosSelected = response.data.objeto.DiasContinuos;
          this.habilSelected = response.data.objeto.DiasHabiles;
          this.porcentajeSelected = response.data.objeto.PorcentajeSueldo;
          this.frecuenciaSelected =
            response.data.objeto.ListaFrecuencia.Lista[
              response.data.objeto.ListaFrecuencia.SelectedValue
            ];
          this.$root.$emit("bv::show::modal", "modalEdicion");
          console.log("tipo de licencia : ",this.tipolicencia)
        })
        .catch(e => {
          console.log("Error", e);
          this.errorHandler(e);
        });
    },

    cambiarLicencia() {
      this.desactivarBoton();
      this.cambiarDetalleDiasLicencia()
        .then(res => {
          this.activarBoton();
          this.showSuccess("Detalle actualizado exitosamente");
          this.$refs.tablaTipoLicencia.refresh();
        })
        .catch(e => {
          this.errorHandler(e);
        });
    },

    eliminarLicencia() {
      this.eliminarDetalleDiasLicencia()
        .then(res => {
          this.showSuccess("Detalle removido exitosamente");
          this.$refs.tablaTipoLicencia.refresh();
        })
        .catch(e => {
          this.errorHandler(e);
        });
    },

    modalEliminar(item, index, button) {
      this.txtDescripcion = item.Descripcion;
      this.txtAntiguedad = item.AntiguedadDias;
      this.txtMinimoDias = item.MinimoDias;
      this.txtMaximoDias = item.MaximoDias;
      this.porcentajeSelected = item.PorcentajeSueldo;
      this.continuosSelected = item.DiasContinuos;
      this.idSeleccionado = item.Id;
      this.tipolicencia = item.TipoLicencia_Id;
      this.selected = item.TipoLicencia_Id;
      this.$root.$emit("bv::show::modal", "modalEliminar", button);
    },
    handleSubmit() {
      this.limpiarFormulario();
      this.$refs.modal.hide();
    },
    limpiarFormulario() {
      this.txtDescripcion = "";
      this.txtAntiguedad = "";
      this.txtMinimoDias = "";
      this.txtMaximoDias = "";
      this.porcentajeSelected = null;
      this.continuosSelected = null;
      this.articuloSelected = null;
      this.selected = null;
      this.value = null;
    },

    cambiarDetalleDiasLicencia() {
      return DetalleDiasLicenciaSvc.cambiar({
        TipoLicencia_Id: this.tipolicencia,
        Descripcion: this.txtDescripcion,
        AntiguedadDias: this.txtAntiguedad,
        MinimoDias: this.txtMinimoDias,
        MaximoDias: this.txtMaximoDias,
        DiasContinuos: this.continuosSelected,
        PorcentajeSueldo: this.porcentajeSelected,
        Frecuencia: this.frecuenciaSelected,
        Id: this.idSeleccionado
      });
    },

    eliminarDetalleDiasLicencia() {
      return DetalleDiasLicenciaSvc.eliminar({
        Id: this.idSeleccionado
      });
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    myProvider: function(ctx) {
      let promise = DetalleDiasLicenciaSvc.getLista({
        id: 0,
        offset: (this.currentPage - 1) * this.perPage,
        limit: this.perPage,
        search: this.filter
      });
      return promise
        .then(r => {
          const items = r.data.rows;
          this.totalRows = r.data.total;
          return items;
        })
        .catch(error => {
          console.log("Error en myProvider");
          this.errorHandler(e);
        });
    },
    obtenerFrecuencias() {
      DetalleDiasLicenciaSvc.getFormData(0)
        .then(response => {
          this.results = response.data;
          this.results.objeto.ListaFrecuencia.Lista.forEach(f => {
            this.frecuencia.push(f);
          });
        })
        .catch(e => {
          console.log("Error: " + e);
          this.errorHandler(e);
        });
    }
  },
  created() {
    this.obtenerFrecuencias();
  }
};
</script>

<style>
.multiple {
  width: 1000px;
}
.primer-fila,
.segunda-fila {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/configuraciones/RegimenLicencia.vue